<template>
    <record-choose-item
        v-bind:className="'choose-record-choose-item'"
        v-bind:recordData="source"
        v-bind:itemFunc="chooseSearchResultSItem">
    </record-choose-item>
</template>

<script>
import RecordChooseItem from '../record/RecordChooseItem.vue'
export default {
    name: 'SearchResultSItem',
    components: { RecordChooseItem },
    props: {
        source: {   
            type: Object,
            default () { return {} }
        }
    },
    methods: {
        chooseSearchResultSItem(data) {
            if(data.selected) {
                this.$store.dispatch('search/addSearchResultSelectedList', {
                    type: 'add', idArr: [data.id]
                });
            }else {
                this.$store.dispatch('search/removeSearchResultSelectedList', {
                    type: 'remove', idArr: [data.id]
                });
            }
        }
    }
}
</script>